import c0 from './flash_message_controller';
import c1 from './lists/details_controller';
import c2 from './lists/list_controller';
import c3 from './loader_controller';
import c4 from './page_controller';
import c5 from './reset_form_controller';
import c6 from './tooltip_controller';
export const definitions = [
	{identifier: 'flash-message', controllerConstructor: c0},
	{identifier: 'lists--details', controllerConstructor: c1},
	{identifier: 'lists--list', controllerConstructor: c2},
	{identifier: 'loader', controllerConstructor: c3},
	{identifier: 'page', controllerConstructor: c4},
	{identifier: 'reset-form', controllerConstructor: c5},
	{identifier: 'tooltip', controllerConstructor: c6},
];
